{
	"itemsAcrossTopics": "{{topicCount}}つのトピックにある{{itemCount}}個のアイテム",
	"language": {
		"select": "言語を選択",
		"display": "表示言語",
		"english": "英語",
		"chinese": "中国語",
		"japanese": "日本語",
		"switchedMessage": "言語が{{from}}から{{to}}に切り替わりました",
		"currentLanguage": "現在の言語は{{langname}}です",
		"switchLanguage": "言語を切り替える",
		"switchTo": "{{language}}に切り替える",
		"sectionTitle": "言語"
	},
	"dashboard": {
		"header": {
			"title": "ホーム",
			"quickStudy": "クイック学習"
		},
		"reviewPrompt": {
			"buttons": {
				"couldBeBetter": "改善の余地あり",
				"itsAwesome": "素晴らしい"
			},
			"title": "お疲れ様でした！",
			"body": "学習への取り組みを見ていて嬉しいです！アプリの体験はいかがですか？ご感想をシェアして、レビューを残していただけませんか？",
			"cta": "後で"
		},
		"actions": {
			"studyWeak": "弱点分野を練習",
			"viewProgress": "進捗を表示",
			"seeRank": "ランキングを見る",
			"seeRankings": "リーダーボードを見る",
			"unlock": "プレミアムコンテンツをアンロック",
			"unlockTooltip": "プレミアムコンテンツをアンロックすることで、限定機能と上級学習教材にアクセスできます",
			"startCustomSession": "カスタムセッションを開始",
			"startCustomSessionTooltip": "あなたの学習に焦点を当てたカスタムセッションを開始します",
			"takeDiagnostic": "診断テストを受ける",
			"takeDiagnosticTooltip": "診断テストを受けて現在のレベルを評価し、それに応じて学習計画をカスタマイズします",
			"viewDiagnostic": "診断結果を見る",
			"viewDiagnosticTooltip": "診断結果を確認して、強みと改善が必要な分野を理解します",
			"viewPodcasts": "ポッドキャストを聴く",
			"viewPodcastsTooltip": "教育ポッドキャストにアクセスして、学習体験を向上させます",
			"upgradeToPremium": "プレミアムにアップグレード",
			"upgradeToPremiumTooltip": "プレミアムにアップグレードして、すべてのコンテンツと機能にアクセスします",
			"extendAccess": "アクセスを延長",
			"extendAccessTooltip": "プレミアムコンテンツへのアクセスを延長します",
			"setExamDate": "試験日を設定",
			"setExamDateTooltip": "試験日を設定して進捗を追跡し、試験の準備をします"
		},
		"stats": {
			"mastery": "習熟度",
			"masteryValue": "{{value}}%",
			"completed": "完了",
			"completedValue": "{{count}}個のアイテム",
			"xpEarned": "獲得",
			"xpEarnedValue": "{{value}} XP",
			"accuracy": "正答率",
			"accuracyValue": "{{value}}%",
			"untilExam": "試験まで",
			"examDate": "試験日",
			"daysLeft": "{{count}}日",
			"pastDue": "期限切れ",
			"setExamDate": "日付を設定"
		},
		"menu": {
			"store": "ストア",
			"settings": "設定"
		},
		"diagnostics": {
			"title": "診断テスト",
			"free": "無料",
			"Reading & Listening": "リーディング＆リスニング",
			"Speaking & Writing": "スピーキング＆ライティング",
			"duration": "{{count}}個の{{item}} • {{minutes}}分",
			"completed": "{{count}}個の{{item}}完了",
			"start": "開始",
			"viewReport": "レポートを見る"
		},
		"skills": {
			"title": "スキル",
			"Reading": "リーディング",
			"Listening": "リスニング",
			"Speaking": "スピーキング",
			"Writing": "ライティング"
		},
		"search": {
			"placeholder": "何でも検索..."
		}
	},

	"appbar": {
		"home": {
			"title": "ホーム",
			"subtitle": "ダッシュボード"
		},
		"progress": {
			"title": "進捗",
			"description": "パフォーマンスと改善が必要な分野を確認"
		},
		"leaderboard": {
			"title": "リーダーボード",
			"description": "他の人と比較してあなたの成績を見る"
		}
	},
	"emptyState": {
		"leaderboard": {
			"title": "まだリーダーがいません",
			"subtitle": "まだデータを収集中です。学習して、後で戻ってきてパフォーマンスを確認してください！"
		},
		"progress": {
			"title": "学習進捗がありません",
			"subtitle": "学習すると、進捗がここに表示されます",
			"cta": "今すぐ学習"
		}
	},
	"errors": {
		"sessionCreation": {
			"title": "エラー",
			"body": "セッション作成に失敗しました。もう一度お試しください"
		}
	},
	"mastery": {
		"labels": {
			"high": "習得済み",
			"medium": "習得に近い",
			"low": "練習が必要",
			"none": "未回答",
			"advanced": "上級",
			"intermediate": "中級",
			"basic": "基礎"
		}
	},
	"leaderboard": {
		"resetIn": "リーダーボードは{{days}}日後にリセットされます",
		"periods": {
			"all_time": "全期間",
			"month": "今月",
			"week": "今週"
		}
	},
	"sessionConfig": {
		"title": "カスタム学習セッション",
		"diagnostic": "診断テスト",
		"skill": "スキル",
		"mastery": "習熟度",
		"setCount": "{{count}}個の{{type}}",
		"dismiss": "OK",
		"status": {
			"notAnswered": "未回答",
			"needsWork": "練習が必要"
		},
		"itemCount": "{{topics}}つのトピックで{{count}}個の問題を完了します",
		"start": "開始",
		"configuringSession": "セッションを設定中...",
		"fetchingContent": "コンテンツを取得中...",
		"preparingMaterials": "教材を準備中...",
		"almostThere": "もうすぐ完了...",
		"startingSession": "セッションを開始中...",
		"playIcon": "play-outline",
		"infoText": "**{{numItems}}**個の{{itemCount}}を完了します。これには約**{{timeString}}**かかります。"
	},
	"learningModes": {
		"questions": "問題",
		"reading": "リーディング",
		"listening": "リスニング",
		"writing": "ライティング",
		"speaking": "スピーキング",
		"readingListening": "リーディングとリスニング",
		"speakingWriting": "スピーキングとライティング"
	},
	"progress": {
		"tagProgress": {
			"subtitle": "{{count}}個の{{type}}にわたる{{numItems}}個の{{item}}試行に基づく",
			"itemCount": "{{count}}個の{{item}}",
			"tooltip": "これは{{count}}個の{{type}}での進捗を示します。現在試行している{{itemCount}}個の{{item}}に基づいています。"
		},
		"itemTypeProgress": {
			"title": "アイテムタイプのパフォーマンス",
			"subtitle": "{{count}}個の{{item}}に基づく",
			"tooltip": "これは{{count}}個の{{type}}でのパフォーマンスを示します"
		},
		"needsImprovement": {
			"title": "改善が必要",
			"subtitle": "向上のため{{type}}を推奨",
			"cta": "学習を開始"
		},
		"mastery": {
			"high": "習得済み",
			"medium": "習得に近い",
			"low": "練習が必要",
			"count": "{{count}}個の{{item}}試行",
			"highTooltip": "{{count}}個の{{item}}を習得しました",
			"mediumTooltip": "順調に進歩しており、{{count}}個の{{item}}を完了しました",
			"lowTooltip": "より多くの練習が必要で、{{count}}個の{{item}}が残っています"
		},
		"stats": {
			"completion": "完了率",
			"completionCount": "{{completed}}/{{total}}個の{{item}}",
			"completionTooltip": "{{total}}個の{{item}}のうち{{completed}}個を完了しました"
		},
		"summary": {
			"title": "学習概要",
			"subtitle": "{{count}}個の{{item}}を試行したに基づく",
			"mastery": "習熟度",
			"quickStats": "クイック統計",
			"tooltip": "このサマリーは{{count}}個の{{item}}での習熟度と完了進捗を示します。パフォーマンスは練習、評価、学習活動を通じて測定されます。"
		},
		"practiceTests": {
			"performanceTooltip": "推定パフォーマンスは{{score}}%です",
			"estimatedPerformance": "推定パフォーマンス"
		}
	},
	"premium": {
		"chip": "プレミアム",
		"tooltip": "プレミアムコンテンツ",
		"upgrade": "プレミアムにアップグレード"
	},
	"purchase": {
		"studyPackDialogTitle": "学習プランをアップグレード",
		"practiceTestDialogTitle": "模擬試験をアンロック",
		"defaultDialogTitle": "学習プランをアップグレード",
		"paywall": {
			"title": "すべてのアイテムをアンロックして、{{date}}の試験準備を最大化しましょう",
			"beforeDate": "{{date}}まで",
			"accessHere": "こちらでアクセス",
			"recommendedPlan": "{{dateText}}の試験に最適な準備をするため、**{{duration}}{{interval}}**プランをお勧めします",
			"purchaseDisclaimer": "購入を確認すると、選択した期間中この製品のコンテンツに完全にアクセスできます。この期間が終了すると、制限されたコンテンツへのアクセスを失います。何らかの理由でアクセス時間を延長したい場合（例：試験日を変更した場合）、追加のアプリ内購入で時間を追加できます。詳細については、[利用規約とプライバシーポリシー]({{tosLink}})をご覧ください。",
			"accesDuration": {
				"yearPlan": "**{{duration}}{{interval}}**プランは延長アクセスを提供し、自分のペースで学習し、試験に包括的に準備する柔軟性を与えます。",
				"moreTime": "より多くの学習時間が必要だと思う場合は、**{{yearPlanDuration}}{{yearPlanInterval}}**プランを検討してください。",
				"otherPlan": "**{{duration}}{{interval}}**プランは**{{expiryText}}**までアクセスを許可し、学習に十分な時間を与えます。{{moreTime}}"
			}
		},
		"success": {
			"headerTitle": "ご購入ありがとうございます！",
			"subtitle": "購入が正常に完了しました",
			"accessGranted": "{{name}}へのアクセスが正常に許可されました",
			"purchaseSuccessful": "{{name}}の購入が成功しました",
			"studyPack": "スタディパック",
			"practiceTest": "模擬試験",
			"documentTitle": "購入"
		}
	},
	"auth": {
		"incorrectPasscode": "パスコードが間違っています",
		"verify": {
			"openEmail": "メールを開いて続行",
			"signInCta": "アカウントを確認中...",
			"signUpCta": "アカウントを作成中...",
			"contactSupport": "メールが届きませんか？スパムフォルダを確認するか",
			"contactSupportLink": "お問い合わせ",
			"resendMagicLink": "マジックリンクを再送信",
			"resendMagicLinkIn": "{{time}}後にマジックリンクを再送信できます",
			"signInBody": "もうすぐ完了です！詳細を確認して{{appName}}アプリに安全にサインインしてください。",
			"signUpBody": "もうすぐ完了です！詳細を確認して{{appName}}アプリのアカウントを作成してください。",
			"magicLinkEmail": "**{{email}}**にマジックリンクを送信しました\nメール内のリンクをクリックして安全にサインインしてください。",
			"magicLinkEmailExpiry": "このリンクは10分後に期限切れになります",
			"confirmEmail": "メールを確認",
			"redirectingToApp": "{{appName}}アプリにリダイレクト中...",
			"appNotOpen": "アプリが開きませんか？下のボタンをクリックして関連アプリを開いてください",
			"openApp": "{{appName}}アプリを開く",
			"installAppPrompt": "何も起こらない場合は、デバイスに{{appName}}アプリがインストールされていることを確認してください",
			"verifyAccountTitle": "アカウントを確認",
			"emailResent": "メールを送信しました。スパムまたは迷惑メールフォルダを含めてメールボックスを確認してください",
			"verificationLinkExpired": "確認リンクの期限が切れました",
			"verificationLinkExpiredBody": "確認リンクは10分後に期限切れになり、一度だけ使用できます。再度サインインして新しいリンクを要求できます",
			"loginAgain": "再度ログイン",
			"contactSupportExpiredLink": "この問題が続く場合は、お知らせください"
		}
	},
	"account": {
		"title": "アカウント設定",
		"subtitle": "アカウント設定を管理",
		"currentExam": "現在の試験",
		"examDate": "試験日",
		"selectDate": "日付を選択",
		"appearance": "外観",
		"features": "機能",
		"audioPlaybackTest": "テスト音声再生ダイアログを表示",
		"darkMode": "ダークモード",
		"accountInfo": "アカウント",
		"name": "名前",
		"email": "メール",
		"dev": "開発",
		"sandbox": "サンドボックス",
		"about": "概要",
		"termsOfService": "利用規約",
		"privacyPolicy": "プライバシーポリシー",
		"support": "サポート",
		"supportEmailBody": "以下の件でお手伝いが必要なため、お問い合わせいたします。 [  ]\n\n\n\n問題をより迅速に解決するために、以下の情報をお役立てください：\n\nアカウントに関連付けられたユーザー名（アプリにログインした状態で設定で確認できます）：\n{{username}}\n\n注文に関連付けられたメールアドレス（アプリにログインした状態で設定で確認できます）：\n{{email}}\n\n注文番号（通常、購入時に送信された領収書メールに記載されています）：\n\n商品を実際に購入した際に、異なる名前やメールアドレスが使用された可能性はありますか？もしそうであれば、それらを教えてください：\n\n姓名：\n\nメールアドレス：",
		"contactSupport": "サポートに連絡",
		"signOut": "サインアウト",
		"signOutConfirmation": "本当にサインアウトしますか？",
		"deleteAccount": "アカウントを削除",
		"platform": "プラットフォーム",
		"partnerships": "パートナーシップ",
		"validUntil": "{{date}}まで有効",
		"extendValidity": "アクセスを延長",
		"frequentlyAskedQuestions": "よくある質問"
	},
	"dialog": {
		"feedback": {
			"defaultFeedbackBody": "何が気に入りましたか？改善できることはありますか？私たちは毎日プラットフォームを改善しており、チームはすべてのフィードバックを読んでいます。ありがとうございます！",
			"title": "改善にご協力ください",
			"body": "アプリがご期待に応えられず申し訳ありません。改善に努めています。**フィードバック**をお聞かせいただけませんか？",
			"placeholder": "フィードバックを入力",
			"cta": "フィードバックを送信"
		},
		"report": {
			"title": "レポートを送信",
			"body": "この回答の問題点を理解するのにご協力ください",
			"cta": "レポートを送信"
		},
		"faqs": {
			"title": "よくある質問",
			"body": "アプリに関するよくある質問です。他にご質問がございましたら、お気軽にお問い合わせください support@memorang.ai"
		},
		"delete": {
			"title": "アカウントを削除",
			"placeholder": "フィードバック",
			"chooseReason": "理由を選択",
			"body": "退会されるのは残念ですが、学業とキャリアの道のりでの成功をお祈りしています！",
			"options": "高すぎる|すでに試験を受けた|コンテンツが気に入らない|機能/機能性の不足|その他",
			"confirmdelete": {
				"title": "アカウント削除を確認",
				"cta": "削除",
				"errorMessage": "申し訳ありませんが、そのメールはこのアカウントと一致しません。もう一度お試しください",
				"successMessage": "アカウントの削除が成功しました！",
				"validEmail": "有効なメールアドレスを入力してください"
			}
		},
		"notifyAppLaunch": {
			"title": "モバイルアプリ待機リストに参加",
			"body": "{{appName}}モバイルアプリがまもなくiPhoneとAndroidで利用可能になります。**すべての地域で同時に利用可能にならない可能性があります。**下のボタンをクリックして、お住まいの地域で利用可能になったときに最初に通知を受け取ってください。",
			"cta": "待機リストに参加",
			"successMessage": "待機リストに参加しました！{{appName}}モバイルアプリが利用可能になったときに通知します。",
			"failedMessage": "待機リストに参加できませんでした。後でもう一度お試しください。"
		}
	},
	"common": {
		"activity": "練習",
		"this": "この",
		"unlock": "アンロック",
		"itemCount": "{{count}}個のアイテム",
		"item": "アイテム",
		"knowMore": "詳細を知る",
		"attempt": "試行",
		"proficiency": "習熟度",
		"items": "アイテム",
		"of": "の",
		"didNotAnswer": "まだ試行していないアイテム",
		"notAnswered": "未回答",
		"attempted": "試行済み",
		"points": "ポイント",
		"eg": "例",
		"performance": "パフォーマンス",
		"details": "詳細",
		"estimatedProficiency": "推定習熟度",
		"keepPracticing": "練習を続けてください！良くできています！",
		"set": "セット",
		"selectTestDate": "試験日を選択",
		"copiedToClipboard": "クリップボードにコピーしました",
		"leaveFeedback": "フィードバックを残す",
		"hint": "ヒント",
		"itemType": "アイテムタイプ",
		"minute": "分",
		"minutes": "分",
		"hour": "時間",
		"hours": "時間",
		"continue": "続行",
		"cancel": "キャンセル",
		"ok": "OK",
		"yes": "はい",
		"free": "無料",
		"correct": "正解",
		"incorrect": "不正解",
		"sec": "秒",
		"marked": "マークされた",
		"skipped": "スキップされた",
		"skill": "スキル",
		"word": "語",
		"submitResponse": "回答を提出",
		"viewDetails": "詳細を表示",
		"week": "週",
		"month": "月",
		"year": "年",
		"on": "で",
		"day": "日",
		"and": "と"
	},
	"session": {
		"attributes": {
			"stimulus": "刺激"
		},
		"stimulusTypes": {
			"reading": "リーディング",
			"listening": "リスニング",
			"speaking": "スピーキング",
			"writing": "ライティング"
		},
		"itemTypes": {
			"MCSS": "単一選択問題",
			"MCSSH": "単一選択ハイライト問題",
			"MCMS": "複数選択問題",
			"MCMSH": "複数選択ハイライト問題",
			"INSERT_TEXT": "テキスト挿入問題",
			"MATCH_MS": "複数項目マッチング問題",
			"MCSSM": "単一選択マッチング問題",
			"MCMSM": "複数選択マッチング問題",
			"MCGS": "空欄選択問題",
			"MCOS": "順序選択問題",
			"LISTENING_REPLAY": "リスニング再生問題",
			"AUDIO_INPUT": "音声入力問題",
			"ACADEMIC_DISCUSSION_RESPONSE": "学術討論回答問題",
			"INTEGRATED_WRITING_RESPONSE": "統合ライティング回答問題"
		},
		"masteryLevels": {
			"basic": "基礎",
			"belowBasic": "基礎未満",
			"lowIntermediate": "初中級",
			"belowLowIntermediate": "初中級未満",
			"highIntermediate": "上中級",
			"advanced": "上級",
			"proficiencySubtitle": "{{trademark}}では、これは**{{minScore}}-{{maxScore}}/30**のスコアに対応します",
			"infoSectionLabel": "{{skill}}セクション情報",
			"infoSectionText": {
				"Reading": "{{trademark}}リーディングセクションは、学術的資料を読み理解する能力を評価します。約700語の2つのリーディング資料が含まれ、それぞれに10問があります。リーディングセクションの完了には約35分かかります。",
				"Listening": "{{trademark}}リスニングセクションは、話し言葉と講義を理解する能力を測定するように設計されています。基本的な理解、話者の態度と確信の理解、情報の接続を含むリスニング材料が含まれます。リスニングセクションの完了には約36分かかります。",
				"Speaking": "{{trademark}}スピーキングセクションは、学術的環境で英語を効果的に使用する能力を測定します。4つの質問/タスクは、学校内外で遭遇する可能性のある現実的な状況に似ています。スピーキングセクションの完了には約16分かかります。",
				"Writing": "{{trademark}}ライティングセクションは、学術的環境で英語を使用する能力を測定します。コンピューターで回答を入力し、ライティングセクションの完了には約29分かかります。"
			}
		},
		"passageStem": {
			"item": "アイテム",
			"of": "の",
			"passage": "パッセージ",
			"lecture": "講義",
			"professorsQuestion": "教授の質問",
			"listen": "聞く",
			"openPassage": "パッセージを開く",
			"notYetInserted": "まだ挿入されていません",
			"insertedAtPosition": "位置 #{{position}} に挿入されました"
		},
		"hint": {
			"show": "ヒントを表示"
		},
		"navigation": {
			"next": "次へ",
			"previous": "前へ",
			"skip": "スキップ",
			"finish": "完了",
			"help": "ヘルプ"
		},
		"stats": {
			"skill": "スキル",
			"answered": "回答済み",
			"speed": "速度",
			"response": "回答",
			"confidence": "信頼度",
			"pointsEarned": "獲得ポイント",
			"word": "語",
			"words": "語数",
			"time_taken": "{{time}} {{sec}}",
			"time_taken_tooltip": "この問題を読んで答えるのに {{time_taken}} 秒かかりました{{end}}",
			"time_taken_tooltip_end": "、この {{stimulus_type}} 刺激を含めて"
		},
		"explanation": {
			"title": "解説",
			"feedback": "フィードバック"
		},
		"followUps": "フォローアップ質問",
		"suggestCorrection": "修正を提案",
		"answer": {
			"correct": "正解",
			"incorrect": "不正解",
			"skipped": "スキップ"
		},
		"confidence": {
			"high": "高",
			"medium": "中",
			"low": "低"
		},
		"endDialog": {
			"title": "学習セッションを終了",
			"confirmEndDiagnostic": "本当にこのセッションを終了しますか？すべての進捗が失われ、再開する必要があります。",
			"confirmEnd": "まだ {{num}} {{itemLabel}} が残っています。今すぐ終了するか、続けてそれらを完了します。",
			"confirmEndNoAnswer": "まだ問題に答えていません。今すぐ終了しますか？",
			"confirmEndNoAnswerPositive": "学習を続ける",
			"confirmEndNoAnswerNegative": "今すぐ終了"
		},
		"permissionDialog": {
			"title": "マイクを許可",
			"descriptionWeb": "音声を録音するにはマイクへのアクセスが必要です。アドレスバーの左側のアイコンをクリックして、マイクの許可を有効にしてください。",
			"descriptionMobile": "音声を録音するにはマイクを使用する必要があります。デバイス設定でマイクの許可を有効にしてください。",
			"ok": "OK",
			"cancel": "キャンセル",
			"openSettings": "設定を開く"
		},
		"audioPlaybackTestDialog": {
			"title": "音声再生をテスト",
			"description": "{{appName}} には刺激、テスト項目、テキスト読み上げなど、複数の音声再生機能が含まれています。最適な体験を確保するため、音声をテストしてください。正常に動作することを確認したら、続行してください。",
			"troubleshooting": {
				"title": "音声問題のトラブルシューティング",
				"volumeTitle": "デバイスの音量を確認",
				"volumeDescriptionWeb": "キーボードコントロールまたはメニュー/タスクバーのシステム音量設定で音量を調整",
				"volumeDescriptionMobile": "デバイスの音量ボタンまたはシステム設定で調整",
				"outputTitle": "音声出力デバイスを確認",
				"outputDescription": "ヘッドフォンを使用している場合は、正しく接続され、アクティブな出力デバイスとして選択されていることを確認",
				"browserTitle": "ブラウザタブの音声を確認",
				"browserDescription": "タブタイトルの横にミュートスピーカーアイコンがあるかどうかを確認し、ある場合はミュートを解除"
			},
			"skipCheck": "次回この確認をスキップ",
			"workingButton": "音声が正常であることを確認",
			"textToHear": "聞こえるはずの音声：{{text}}"
		},
		"overall": "全体",
		"feedback": {
			"greatJob": "よくできました！",
			"niceWork": "いい仕事です！",
			"wellDone": "よくやりました！",
			"excellent": "素晴らしい！",
			"outstanding": "傑出している！",
			"fantastic": "素晴らしい！",
			"brilliant": "見事！",
			"amazingWork": "驚くべき仕事！",
			"superb": "卓越している！",
			"wayToGo": "その調子で！",
			"perfect": "完璧！",
			"impressive": "印象的！",
			"stellarWork": "優秀な仕事！",
			"awesomeJob": "素晴らしい仕事！",
			"excellentEffort": "優秀な努力！",
			"remarkable": "注目すべき！",
			"youNailedIt": "やりました！",
			"terrificWork": "素晴らしい仕事！",
			"negative": {
				"hangIn": "頑張って",
				"youCanDoIt": "あなたならできます",
				"keepTrying": "挑戦し続ければ成功します",
				"persistenceKey": "継続が鍵です",
				"practiceMakesPerfect": "継続は力なり",
				"keepGoingStrong": "頑張り続けて"
			}
		},
		"subskills": {
			"content": {
				"title": "内容",
				"integratedWriting": "あなたの回答は講義の要点を正確に提示し、読解材料と関連付ける必要があります。重大な省略、不正確さ、またはいずれかの情報源の見解の誤った表現を避けてください。",
				"academicDiscussionWriting": "あなたの回答は教授の質問またはクラス討論のトピックに直接応答する必要があります。関連する視点や意見を提供し、例、個人的経験、または論理的推論でサポートしてください。トピックに関連性を保ち、討論に意味のある貢献をしてください。",
				"integratedSpeaking": "リスニング材料（読解材料が含まれる場合）の要点を正確に要約または統合してください。材料間の関連性を明確に確立してください（例：講義が読解材料をどのように反駁または支持するか）。重大な省略や内容の誤った表現を避けてください。",
				"independentSpeaking": "明確な個人的見解や選択を述べてプロンプトに十分に応答し、適切な理由と例でサポートしてください。内容の関連性と焦点を保ち、回答が質問に直接関連することを確認してください。"
			},
			"languageUse": {
				"title": "言語使用",
				"integratedWriting": "あなたの回答は正確な文法、適切な語彙、明確な文構造を使用する必要があります。意味の表現や流暢さを妨げない限り、小さなエラーは許容されます。",
				"academicDiscussionWriting": "クラスフォーラムに適した学術言語を使用して、明確で簡潔な文章を示してください。基本的な文法と文構造は正しく、エラーは最小限に抑え、明確さに影響しないようにしてください。観点を正確に伝える語彙を選び、討論環境での自然なトーンを維持してください。",
				"integratedSpeaking": "必要な情報を伝えるために文法的に正確な文と語彙を使用してください。小さなミスは許容されますが、混乱や頻繁な言い直しを引き起こしてはいけません。情報源材料の様々な観点間の関係を効果的に表現するために、十分な構造と語彙の習得を示してください。",
				"independentSpeaking": "あなたの考えを表現するために語彙と文法を正確に使用してください。小さなエラーは許容されますが、回答の流暢さや明確さに大きく影響してはいけません。連贯で流暢な表現をサポートするために多様な文構造の使用に努めてください。"
			},
			"organizationAndDevelopment": {
				"title": "構成と発展",
				"integratedWriting": "あなたの回答は明確な序論、本論、結論を含んで、よく構成されている必要があります。論理的な転換を使用し、あなたの論証を効果的にサポートするために観点を十分に発展させてください。",
				"academicDiscussionWriting": "各観点が前の観点に基づいて構築されるように、短いが一貫性のある回答を書いてください。短い投稿であっても、簡潔な序論（立場を述べる）、本論（理由や例でサポート）、簡潔な結論や要約を含めてください。観点間に論理的な関連性を築き、クラスメートがあなたの論証を簡単に理解できるようにしてください。"
			},
			"topicDevelopment": {
				"title": "トピック発展",
				"integratedSpeaking": "リスニング材料（読解材料が含まれる場合）の要点を正確に要約または統合してください。材料間の関連性を明確に確立してください（例：講義が読解材料をどのように反駁または支持するか）。重大な省略や内容の誤った表現を避けてください。",
				"independentSpeaking": "明確な個人的見解や選択を述べてプロンプトに十分に応答し、適切な理由と例でサポートしてください。内容の関連性と焦点を保ち、回答が質問に直接関連することを確認してください。"
			},
			"delivery": {
				"title": "話し方",
				"integratedSpeaking": "明確で自然なペースで話し、正しい発音とイントネーションを保ってください。時々の一時停止、軽微な発音エラー、または小さなペースの問題は許容されますが、全体的な理解に影響してはいけません。あなたの回答は聴衆にとって理解しやすいものであるべきです。",
				"independentSpeaking": "自然に話し、適切な音量とペースを保ってください。発音とイントネーションは聴衆があなたの表現を簡単に理解できるほど明確であるべきです。時々の小さなエラーや躊躇は理解に影響してはいけません。"
			}
		},
		"aiStates": {
			"processingAudio": "音声を処理中...",
			"analyzingSpeech": "あなたの音声を分析中...",
			"gradingResponse": "あなたの回答を採点中...",
			"generatingFeedback": "フィードバックを生成中...",
			"processingText": "テキストを処理中..."
		}
	},
	"feedback": {
		"successMessage": "フィードバックをありがとうございます！"
	},
	"report": {
		"pointsInfo": {
			"feedbackText": {
				"advanced": "優秀なパフォーマンス——卓越性を追求し続けてください！",
				"highIntermediate": "とても良くできています——強みを磨き続けてください！",
				"lowIntermediate": "着実に進歩しています——継続してください！",
				"basic": "能力向上に向けて努力を続けてください！"
			},
			"infoText": "あなたは **{{numActivities}} {{activityLabel}}** を完了して、{{skillsText}} {{skills}} を練習しました. {{skillDetails}}. 全体的に、**{{numPointsEarned}} ポイント**を獲得し、{{thisText}} {{skills}} で **{{compositeLevel}} レベル** を示しました。{{compositeFeedback}}",
			"infoText.singleSkill": "あなたは **{{itemCount}} {{itemLabel}}** を完了し、**{{skill_1}}** スキルに焦点を当てました。**{{skill_1_score}} ポイント（総計 {{skill_1_total}} ポイント）**を獲得し、**{{proficiency}}** レベルに達しました。{{compositeFeedback}}",
			"infoText.multiSkill": "あなたは **{{itemCount}} {{itemLabel}}** を完了し、**{{skills_text}}** スキルを練習しました。{{skill_details}} 全体的に、**{{overall_score}} ポイント（総計 {{overall_total}} ポイント）**を獲得し、これらのスキルで **{{overall_proficiency}}** レベルに達しました。{{compositeFeedback}}",
			"skillDetails": "**{{skill}}** で、**{{score}} ポイント（総計 {{total}} ポイント）**を獲得し、**{{proficiency}}** レベルを示しました。"
		},
		"productName": "{{examName}} {{type}}",
		"practiceTests": "模擬試験",
		"studyPack": "スタディパック",
		"diagnosticCompleted": "診断評価完了",
		"practiceTestCompleted": "模擬試験完了",
		"studySessionCompleted": "学習セッション完了",
		"diagnosticSessionCompleted": "診断評価セッション完了",
		"answered": "回答済み",
		"answeredTooltip": "回答した問題数",
		"correct": "正解",
		"correctTooltip": "正しく回答した問題数",
		"accuracy": "正答率",
		"accuracyTooltip": "正しく回答した問題の割合",
		"duration": "所要時間",
		"durationTooltip": "テスト完了にかかった時間",
		"timeElapsed": "経過時間",
		"timeElapsedValue": "{{time}} {{sec}}",
		"timeElapsedTooltip": "テスト完了にかかった時間",
		"avgSpeed": "平均速度",
		"avgSpeedValue": "{{speed}} {{sec}}",
		"avgSpeedTooltip": "各問題の回答にかかった時間",
		"hintsUsed": "使用したヒント",
		"hintsUsedTooltip": "このセッションで使用したヒント数",
		"pointsEarned": "獲得ポイント",
		"pointsEarnedDescription": "{{numTotalPoints}} ポイント中 {{numPointsEarned}} ポイントを獲得しました",
		"stats": {
			"answered": "回答済み",
			"time elapsed": "経過時間",
			"avg speed": "平均速度",
			"hints used": "使用したヒント"
		},
		"actions": {
			"studyMore": "続けて学習",
			"reviewAnswers": "回答を復習"
		},
		"performance": {
			"title": "パフォーマンス",
			"subtitle": "{{count}} 個のアイテムに基づく",
			"correct": "正解",
			"correctItems": "{{count}} 個",
			"incorrect": "不正解",
			"incorrectItems": "{{count}} 個のアイテム"
		},
		"mastery": {
			"performanceTitle": "パフォーマンス",
			"sessionMasteryTitle": "推定習熟度",
			"subtitle": "このセッションの {{count}} 個の{{item}} に基づく",
			"correct": "正解",
			"incorrect": "不正解",
			"marked": "マークされた",
			"skipped": "スキップされた"
		},
		"sessionAnalysis": {
			"title": "セッション分析",
			"subtitle": "個人化された分析と推奨事項",
			"viewFullAnalysis": "完全な分析を表示",
			"menuActions": {
				"copy": "コピー",
				"altCopy": "サマリーテキストをコピー",
				"altPositiveFeedback": "これは役立ちます",
				"altNegativeFeedback": "これはもっと良くできます",
				"positiveFeedback": "良い回答",
				"negativeFeedback": "良くない回答",
				"reportIssue": "報告",
				"altReportIssue": "この回答を報告",
				"emailSummary": "サマリーを送信",
				"emailAlreadySent": "送信済み",
				"copiedAnalysis": "分析をクリップボードにコピーしました",
				"emailSent": "{{email}} に送信しました。メールが届かない場合は、スパム、迷惑メール、最近削除されたフォルダを確認するか、IT管理者にお問い合わせください",
				"emailFailed": "{{email}} への送信に失敗しました",
				"emailInstructionMessage": "メールが届かない場合は、スパム、迷惑メール、最近削除されたフォルダを確認するか、IT管理者にお問い合わせください"
			},
			"feedbackDialog": {
				"title": "改善にご協力ください",
				"body": "私たちはほぼ毎日改善しており、改善に決意を持っています。**フィードバック**をお聞かせいただけませんか？",
				"placeholder": "フィードバックを入力",
				"cta": "フィードバックを送信",
				"successMessage": "フィードバックをありがとうございます！",
				"feedbackLimitError": "フィードバックは最低10文字必要です"
			}
		}
	},
	"encouragements": {
		"positive": {
			"great": "よくできました！",
			"wellDone": "よくやりました！",
			"impressive": "印象的です！",
			"amazing": "すごいです！",
			"awesome": "素晴らしいです！",
			"onARoll": "調子がいいですね！",
			"quitePerformance": "優秀なパフォーマンス！",
			"fantasticEffort": "素晴らしい努力！",
			"keepItUp": "その調子で！",
			"knowledgeCourses": "知識が湧き出ています！"
		},
		"negative": {
			"hangIn": "頑張って",
			"youCanDoIt": "あなたならできます",
			"keepTrying": "挑戦し続ければ成功します",
			"improvementSteps": "改善は一歩ずつです",
			"learnFromWrong": "間違いも学習の機会です",
			"persistenceKey": "継続が鍵です",
			"practiceMakesPerfect": "継続は力なり",
			"keepGoingStrong": "頑張り続けて"
		}
	},
	"aila": {
		"askYourOwnQuestion": "自分の質問をする"
	},
	"recorder": {
		"alert": {
			"title": "最大時間に到達しました",
			"body": "録音は最大時間{{maxDuration}}秒に達したため停止されました。"
		},
		"tapToRecord": "ボタンをタップして録音を開始",
		"uiElementPressed": "録音停止 - 録音中に刺激が開かれました。"
	},
	"writing": {
		"placeholder": "ここに回答を書いてください...",
		"wordCount": "{{count}} {{word}}",
		"title": "あなたの回答",
		"submit": "提出"
	},
	"navbar": {
		"home": "ホーム",
		"progress": "進捗",
		"leaderboard": "リーダー",
		"store": "ストア",
		"more": "その他",
		"redeem": "還元",
		"study-pack": "スタディパック",
		"podcasts": "ポッドキャスト"
	},
	"tts": {
		"tooltip": "このテキストを聞く"
	},
	"commandBar": {
		"placeholder": "何でも検索...",
		"accessibilityLabel": "コマンドバー",
		"accessibilityHint": "アクティベートして検索またはコマンドを使用",
		"actions": {
			"home": "ホームに行く",
			"progress": "進捗に行く",
			"changeTheme": "テーマを変更",
			"leaderboard": "リーダーボードに行く",
			"settings": "設定に行く",
			"premium": "プレミアムにアップグレード",
			"setExamDate": "試験日を設定",
			"startSession": "学習を開始"
		}
	},
	"noInternetAccess": {
		"title": "インターネットアクセスなし",
		"subtitle": "このアプリを使用するにはインターネットアクセスが必要です。WiFiとデータ設定を確認してください",
		"retry": "再試行",
		"connectionRestored": "接続が復旧しました！オンラインに戻りました"
	},
	"onboarding": {
		"steps": {
			"welcome": {
				"title": "TOEFL Practiceへようこそ！",
				"description": "TOEFL iBT公式AIコーチ",
				"cta": "始める",
				"bottomLabelMobile": "あなたに合わせた学習プランを作成し、AIコーチを効果的に使用する方法をお見せします"
			},
			"goal": {
				"title": "あなたの目標は何ですか？",
				"description": "TOEFL iBTの目標に最も適した説明を選択してください",
				"cta": "続行"
			},
			"testDate": {
				"title": "試験日を設定",
				"description": "既知または予想される試験日に基づいてリマインダーを送信し、学習プランをカスタマイズします",
				"cta": "続行",
				"bottomLabel": "この設定はいつでも変更できます。"
			},
			"skills": {
				"title": "仕組み",
				"description": "TOEFL iBTは4つのコアスキルをテストします：リーディング、リスニング、スピーキング、ライティング",
				"cta": "開始",
				"bottomLabel": "アプリのコア機能の使用方法を理解するためのクイックデモ体験"
			},
			"features": {
				"title": "準備完了！",
				"description": "学んだ内容は以下の通りです：",
				"descriptionMobile": "できることは以下の通りです：",
				"cta": "診断テストを開始",
				"secondaryCta": "ホームに戻る",
				"bottomLabel": "アプリを探索するか、無料の診断テストをすぐに開始"
			}
		},
		"goals": {
			"firstTime": {
				"label": "初回受験",
				"description": "初めて試験を受けます"
			},
			"retaking": {
				"label": "再受験",
				"description": "スコア向上のために再受験します"
			},
			"exploring": {
				"label": "探索理解",
				"description": "試験により慣れ親しみ、準備度を評価したいです"
			}
		},
		"actions": {
			"skip": "スキップ"
		},
		"features": {
			"confidence": {
				"label": "進捗を追跡するために信頼度を設定",
				"description": "これにより、アプリがあなたから学習し、よりパーソナライズされた体験を提供できます"
			},
			"verified": {
				"label": "回答を提出してフィードバックを取得",
				"description": "TOEFL AIがあなたの具体的な回答に基づいてパーソナライズされたフィードバックを生成します"
			},
			"assistant": {
				"label": "AI学習アシスタントに質問",
				"description": "各アイテムを深く理解し、スキル向上の方法を学習します"
			}
		},
		"skills": {
			"reading": "リーディング",
			"listening": "リスニング",
			"speaking": "スピーキング",
			"writing": "ライティング"
		}
	}
}
